var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFacebookEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "30px",
    viewBox: "0 0 19 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFacebookEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,9.875 L11.75,7.125 C11.75,6.59714323 12.2895923,6.125 13,6.125 L15.75,6.125 L15.75,0.25 L11,0.25 C7.29240774,0.25 4.25,2.91210677 4.25,6.25 L4.25,9.875 L0.25,9.875 L0.25,15.75 L4.25,15.75 L4.25,29.75 L11.75,29.75 L11.75,15.75 L15.4817949,15.75 L18.1675092,9.875 L11.75,9.875 Z M14.5182051,14.25 L10.25,14.25 L10.25,28.25 L5.75,28.25 L5.75,14.25 L1.75,14.25 L1.75,11.375 L5.75,11.375 L5.75,6.25 C5.75,3.78839323 8.07959226,1.75 11,1.75 L14.25,1.75 L14.25,4.625 L13,4.625 C11.5024077,4.625 10.25,5.72085677 10.25,7.125 L10.25,11.375 L15.8324908,11.375 L14.5182051,14.25 Z M14.3178941,14.6881802 L15,14.25 L14.5182051,14.25 L14.3178941,14.6881802 Z",
    id: "icFacebookEditProfile",
    fill: "#333333",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebookEditProfile);
export default __webpack_public_path__ + "static/media/icFacebookEditProfile.4b989007996c73ddd7dc34ebac495633.svg";
export { ForwardRef as ReactComponent };